<template>
  <span class="footer">
    {{
      $t('engineering.chromatography.methods-and-diagnostics.individual-analysis.typical-values')
    }}:
    <span
      v-for="(value, gas) in data.typicalValues"
      :key="gas"
      class="footer__gas-item"
      v-show="value"
    >
      <span
        class="footer__gas-text-wrapper"
      >
        <gas-label :value="gas" /> = {{ $n(value) }}
      </span>
    </span>
  </span>
</template>

<style lang="sass" scoped>
.footer
  font-size: .95rem
  &__gas-item:not(:last-child)::after
      content: ' | '
  &__gas-text-wrapper
    white-space: nowrap
</style>

<script>
import GasLabel from '../common/GasLabel';

export default {
  components: {
    GasLabel,
  },
  props: {
    data: null,
  },
};
</script>
